"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arsoli": {
    "b9a71bdf": [{
      "hkey": "69275cc8",
      "slug": "arsoli",
      "name": "Arsoli",
      "primary": true,
      "skipSearch": false
    }],
    "molette": [{
      "hkey": "69275cc8",
      "slug": "arsoli",
      "name": "Arsoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b8f8fee": [{
      "hkey": "69275cc8",
      "slug": "arsoli",
      "name": "Arsoli",
      "primary": true,
      "skipSearch": false
    }],
    "piani-uggi": [{
      "hkey": "69275cc8",
      "slug": "arsoli",
      "name": "Arsoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "87a4bfe1": [{
      "hkey": "69275cc8",
      "slug": "arsoli",
      "name": "Arsoli",
      "primary": true,
      "skipSearch": false
    }],
    "stazione-ff-ss": [{
      "hkey": "69275cc8",
      "slug": "arsoli",
      "name": "Arsoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;